import React from 'react';
import {
  Box,
  Drawer,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
  BOOKING_DRAWER_ACCENT,
  getBookingDrawerFooterSx,
  getBookingDrawerHeaderSx,
  getBookingDrawerPaperSx,
  getBookingDrawerTheme,
} from '../../../utils/bookingDrawerLayout';
import { getDrawerRootSx } from '../../../utils/drawerOverlayProps';

export default function CashCounterDrawerShell({
  open,
  onClose,
  title,
  icon: Icon,
  isDark,
  children,
  footer,
  overlay,
  disableClose = false,
}) {
  const drawerTheme = getBookingDrawerTheme(isDark);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={disableClose ? undefined : onClose}
      sx={getDrawerRootSx()}
      PaperProps={{
        sx: getBookingDrawerPaperSx(isDark, {
          width: { xs: '100%', sm: 600 },
        }),
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', position: 'relative', overflow: 'hidden' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 1.5,
            ...getBookingDrawerHeaderSx(isDark),
          }}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            {Icon && <Icon sx={{ color: BOOKING_DRAWER_ACCENT, fontSize: 24 }} />}
            <Typography variant="h6" sx={{ color: isDark ? drawerTheme.text : '#333', fontWeight: 700 }}>
              {title}
            </Typography>
          </Stack>
          <IconButton onClick={onClose} disabled={disableClose} size="small" aria-label="Close drawer">
            <CloseIcon sx={{ color: isDark ? drawerTheme.subtleText : '#666' }} />
          </IconButton>
        </Box>

        <Box sx={{ flex: 1, overflow: 'auto', p: 2 }}>{children}</Box>

        {footer && (
          <Box
            sx={{
              p: 1.5,
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 1,
              ...getBookingDrawerFooterSx(isDark),
            }}
          >
            {footer}
          </Box>
        )}
        {overlay}
      </Box>
    </Drawer>
  );
}
